import Clickable from './Clickable';

export type { AnchorProps, ButtonProps, ClickableProps } from './Clickable';
export default Clickable;
